import {
  findItemById,
  getValueByPath,
  setValueByPath,
  updateClassesInLayout,
  updateOnlyElementConfigInLayout,
  updateStyleInLayout,
  updateTableConfig
} from "../utils";

const useSaveConfig = ({ layoutConfig, setLayoutConfig, editElement }) => {
  const elementConfig = editElement?.config || null;

  const saveEditElement = (config, elementId, otherInfo) => {
    if ((elementConfig && elementConfig.otherInfo && elementConfig.otherInfo.path) || (otherInfo && otherInfo.path)) {
      let pathId = elementConfig?.otherInfo?.path[0];
      let actualPath = elementConfig?.otherInfo?.path[1];
      if (!pathId) {
        pathId = otherInfo.path[0];
        actualPath = otherInfo.path[1];
      }
      const mainElement = findItemById(layoutConfig || [], pathId);
      const arrayElement = getValueByPath(mainElement, actualPath);
      if (elementConfig && elementConfig.type === "table" && elementConfig.subType) {
        config = updateTableConfig(arrayElement, elementConfig.id, elementConfig.subType, config);
      }
      const newLayout = updateOnlyElementConfigInLayout(arrayElement, elementId, config);
      config = setValueByPath(mainElement, actualPath, newLayout);
      const final = updateOnlyElementConfigInLayout(layoutConfig, pathId, config.config);
      setLayoutConfig(final);
    } else {
      if (elementConfig && elementConfig.type === "table" && elementConfig.subType) {
        config = updateTableConfig(layoutConfig, elementConfig.id, elementConfig.subType, config);
      }
      if (elementConfig && elementConfig.type === "rv_table" && elementConfig.subType === "edit_column") {
        const e = findItemById(layoutConfig || [], elementConfig.id);
        config = {
          ...e.config,
          columns: e.config.columns.map((column) => (column.id === config.id ? config : column))
        };
      }
      const newLayout = updateOnlyElementConfigInLayout(layoutConfig, elementId, config);
      setLayoutConfig(newLayout);
    }
  };

  const saveElementClasses = (newClasses, elementId) => {
    if (editElement.type === "multi_field") {
      const newLayout = saveMultipleElementClasses(elementConfig.items, layoutConfig, newClasses);
      setLayoutConfig(newLayout);
      return;
    }
    if (elementConfig && elementConfig.otherInfo && elementConfig.otherInfo.path) {
      const mainElement = findItemById(layoutConfig || [], elementConfig.otherInfo.path[0]);
      const arrayElement = getValueByPath(mainElement, elementConfig.otherInfo.path[1]);
      const newLayout = updateClassesInLayout(arrayElement, elementId, newClasses);
      const config = setValueByPath(mainElement, elementConfig.otherInfo.path[1], newLayout);
      const final = updateOnlyElementConfigInLayout(layoutConfig, elementConfig.otherInfo.path[0], config.config);
      setLayoutConfig(final);
    } else {
      const newLayout = updateClassesInLayout(layoutConfig, elementId, newClasses);
      setLayoutConfig(newLayout);
    }
  };

  const saveElementDimensions = (style, elementId) => {
    if (elementConfig && elementConfig.otherInfo && elementConfig.otherInfo.path) {
      const mainElement = findItemById(layoutConfig || [], elementConfig.otherInfo.path[0]);
      const arrayElement = getValueByPath(mainElement, elementConfig.otherInfo.path[1]);
      const newLayout = updateStyleInLayout(arrayElement, elementId, style);
      const config = setValueByPath(mainElement, elementConfig.otherInfo.path[1], newLayout);
      const final = updateOnlyElementConfigInLayout(layoutConfig, elementConfig.otherInfo.path[0], config.config);
      setLayoutConfig(final);
    } else {
      const newLayout = updateStyleInLayout(layoutConfig, elementId, style);
      setLayoutConfig(newLayout);
    }
  };

  return { saveEditElement, saveElementClasses, saveElementDimensions };
};

const saveMultipleElementClasses = (elementMap, layoutConfig, newClasses) => {
  const groupedByPath = new Map(); // Map<string, string[]> (pathKey -> elementIds[])
  const noPathElementIds = [];

  for (const [id, { otherInfo }] of Object.entries(elementMap)) {
    if (otherInfo?.path) {
      const pathKey = JSON.stringify(otherInfo.path); // Stable key for grouping
      if (!groupedByPath.has(pathKey)) groupedByPath.set(pathKey, []);
      groupedByPath.get(pathKey).push(id);
    } else {
      noPathElementIds.push(id);
    }
  }

  // Deep update using path
  let updatedLayout = layoutConfig;
  for (const [pathKey, elementIds] of groupedByPath.entries()) {
    const path = JSON.parse(pathKey);
    const mainElement = findItemById(updatedLayout, path[0]);
    const arrayElement = getValueByPath(mainElement, path[1]);
    const newLayout = updateClassesInLayout(arrayElement, elementIds, newClasses);
    const config = setValueByPath(mainElement, path[1], newLayout);
    updatedLayout = updateOnlyElementConfigInLayout(updatedLayout, path[0], config.config);
  }

  // Flat update for elements without path
  if (noPathElementIds.length > 0) {
    updatedLayout = updateClassesInLayout(updatedLayout, noPathElementIds, newClasses);
  }
  return updatedLayout;
};

export default useSaveConfig;
